import React from 'react'

export default props => (
    <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14.17 14.17"
        {...props}
    >
        <path
            d="M993.14,493.5l7.09,5.64-.44.45-6.65-5.35-6.64,5.35-.45-.45,1.19-.92v-3.54h2.36v1.66Zm0,1.77,5.91,4.72v7.68h-4.14V503h-3.54v4.72h-4.13V500Z"
            transform="translate(-986.05 -493.5)"
        />
    </svg>
)
